import type { RutaProd } from "../../../../runtime/rutas";
export default {
  "ruta": "/sistema/cedis/warehouse/inventory",
  "documento": "cedis",
  "acceso": "sesion",
  "filas": [
    "042"
  ],
  "cita": "Areas/CEDIS/Controllers/WarehouseController.cs"
} satisfies RutaProd;
